import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/features/auth/stores/authStore";

/**
 * Layout mínimo, sem o chrome do portal (sidebar, topbar, banners, toasts
 * de notificação). Para páginas-documento destinadas a impressão / download
 * em PDF: renderiza só o conteúdo, ainda atrás do guard de autenticação.
 *
 * Diferente do AppLayout, não chama useNotificationsConnection() — assim a
 * página não dispara popups de lembrete/lead enquanto o usuário imprime.
 *
 * Veja ContractMinutaPage (/contracts/:id/minuta).
 */
export function PrintLayout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
